<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Registro de asistencia</span>
      </h5>
    </div>
    <div class="row">
    <div class="col-md-6">
      <div class="input-group col-xs-12">
        <input type="text" class="form-control" ref="code" autofocus placeholder="Código de tarjeta" v-model="codeCardIn">
        <span class="input-group-append">
          <button class="btn btn-primary" type="button" v-on:click="clearInput">Limpiar</button>
        </span>
      </div>
    </div>
    <div class="col-md-6 text-center">
      <div>
        <b-form-checkbox v-model="entry" name="check-button" switch>
          <b>{{ entry ? 'Entrada' : 'Salida' }}</b>
        </b-form-checkbox>
      </div>
    </div>
  </div>
    <b-modal id="success-register" ref="modal" :title="entry ? 'Entrada exitosa' : 'Salida exitosa'" hide-footer>
      <b-row class="justify-content-center">
        <b-col>
          <img
            :src="`${attendance.student.pathAvatar}?tr=w-300`"
            @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
            width="200" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
        </b-col>
      </b-row>
      <b-row class="justify-content-center ml-2">
        <b-col sm="12" md="9">
          <b>Nombre:</b> {{ attendance.student.name + ' ' + attendance.student.lastName}}
        </b-col>
      </b-row>
      <b-row class="ml-2">
        <b-col sm="12" md="6">
          <b>Identificación:</b> {{ attendance.student.cc}}
        </b-col>
        <b-col sm="12" md="6">
          <b>Grado:</b> {{ attendance.student.grade }}
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  showConfirmButton: false,
  buttons: false,
  timer: 3000,
})
export default {
  name: 'Resgister',
  data() {
    return {
      grades: {},
      entry: true,
      codeCardIn: '',
      attendance: {
        student: {
          pathAvatar: '',
        },
      },
      userSelected: false,
    }
  },
  watch: {
    codeCardIn: function(val) {
      this.debounce(val, 250)
    },
    entry: function(val) {
      this.$refs.code.focus()
    },
  },
  methods: {
    clearInput: function() {
      this.codeCardIn = ''
      this.userSelected = false
      this.$refs.code.focus()
    },
    loadUser: function() {
      if (this.codeCardIn.length !== 0) {
        if (this.entry) {
          apiClient.post('attendance', { codeCard: this.codeCardIn }).then(response => {
            this.attendance = response.data
            this.$bvModal.show('success-register')
            setTimeout(() => {
              this.$bvModal.hide('success-register')
              this.clearInput()
            }, 2000)
          }).catch(e => {
            Toast.fire('Error', 'El usuario no fue encontrado en el sistema', 'error')
            this.clearInput()
          })
        } else {
          apiClient.patch('attendance', { codeCard: this.codeCardIn }).then(response => {
            this.attendance = response.data
            this.$bvModal.show('success-register')
            setTimeout(() => {
              this.$bvModal.hide('success-register')
              this.clearInput()
            }, 2000)
          }).catch(e => {
            Toast.fire('Error', 'El usuario no fue encontrado en el sistema', 'error')
            this.clearInput()
          })
        }
      }
    },
    debounce: function(val, wait) {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.loadUser(val)
      }, wait)
    },
  },
  mounted: function() {
    this.clearInput()
  },
}
</script>
